import { render, staticRenderFns } from "./ProductCombinationsToMarket.vue?vue&type=template&id=21b915c4&scoped=true&"
import script from "./ProductCombinationsToMarket.vue?vue&type=script&lang=js&"
export * from "./ProductCombinationsToMarket.vue?vue&type=script&lang=js&"
import style0 from "./ProductCombinationsToMarket.vue?vue&type=style&index=0&id=21b915c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b915c4",
  null
  
)

export default component.exports